var map = {
	"./1.png-comp.jpg": 8834,
	"./2.png-comp.jpg": 1167,
	"./3.png-comp.jpg": 5798,
	"./4.png-comp.jpg": 1392,
	"./5.png-comp.jpg": 9301
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8322;